<template>
  <div class="syncorguser">
    <Card>
      <ul>
        <li>企业微信导入请按顺序执行下列五个企业微信导入按钮</li>
        <li v-for="operate in newSyncOperates">
          <span>{{operate.title}}</span>
          <Button class="sync-btn" type="primary" size="small" @click="toNewSyncOperate(operate.operateUrl, operate.title)">执行</Button>
        </li>
        <li v-for="operate in syncOperates">
          <span>{{operate.title}}</span>
          <Button class="sync-btn" type="primary" size="small" @click="toSyncOperate(operate.operateUrl, operate.title)">执行</Button>
        </li>
      </ul>
    </Card>
  </div>
</template>

<script>
import axios from 'axios'
import requestUrls from '@/lib/requestUrls'
import url from '@/lib/userUrl'
// import ajax from '@/lib/ajax'

const ajax = axios.create({
  baseURL: url,
})
ajax.interceptors.request.use(config => {
  if (!!window.abp.auth.getToken()) {
		config.headers.common["Authorization"] = "Bearer " + window.abp.auth.getToken();
	}
	config.headers.common[".AspNetCore.Culture"] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");
	config.headers.common["Abp.TenantId"] = window.abp.multiTenancy.getTenantIdCookie();
	return config;
})

export default {
  data() {
    return {
      syncOperates: [
        {
          title: '企业微信 -> 企业邮箱',
          operateUrl: `${requestUrls.apiUrl}/fr/wechatExmail/synExmail`,
        },
        {
          title: '考勤同步',
          operateUrl: `http://qy.chinapsp.cn:5000/Attensyn/synchronization`,
        },
        {
          title: '备份打卡记录',
          operateUrl: `${requestUrls.apiUrl}/fr/zk/backupAccMonitorLog`,
        },
        {
          title: '将分公司打卡数据插入到打卡记录表中',
          operateUrl: `${requestUrls.apiUrl}/fr/zk/transferCheckLogToCheckRecordInDatabase`,
        }
      ],
      newSyncOperates: [
        {
          title: '1.企业微信 -> ABP组织',
          key: 'signal',
          operateUrl: '/api/services/app/Synchronize/MatchDepartment'
        },
        {
          title: '2.企业微信 -> ABP角色标签',
          key: 'signal',
          operateUrl: '/api/services/app/Synchronize/MatchTag'
        },
        {
          title: '3.企业微信 -> ABP用户',
          key: 'signal',
          operateUrl: '/api/services/app/Synchronize/MatchUser'
        },
        {
          title: '4.企业微信 -> ABP用户组织关联',
          key: 'signal',
          operateUrl: '/api/services/app/Synchronize/MatchDepartmentUsers'
        },
        {
          title: '5.企业微信 -> ABP用户角色关联',
          key: 'signal',
          operateUrl: '/api/services/app/Synchronize/MatchTagUser'
        }
      ]
    }
  },
  methods: {
    async toSyncOperate(url, title = '同步') {
      this.$Spin.show()
      try {
        let rep = await axios.get(url)
        this.$Spin.hide()
        if (rep.data.code === '200' || rep.data.success || rep.data.errcode === 0) {
          this.$Notice.success({
            title: '同步成功',
            desc: title,
            duration: 0,
          })
        } else {
          this.$Notice.error({
            title: '同步失败',
            desc: title,
            duration: 0,
          })
        }
      } catch(err) {
        this.$Spin.hide()
        // this.$Message.error('同步失败')
        this.$Notice.error({
          title: '同步失败',
          desc: title,
          duration: 0,
        })
      }
    },
    async toNewSyncOperate(url, title = '同步') {
      this.$Spin.show()
      try {
        let rep = await ajax.post(url)
        this.$Spin.hide()
        if (rep.data.success) {
          // if (key === 'user') {
          //   let organization = rep.data.result.results['组织']
          //   let user = rep.data.result.results['用户']
          //   this.$Modal.success({
          //     title: '同步成功',
          //     content: `<div>组织：新增[${organization.createCount}];匹配[${organization.matchCount}];删除[${organization.deleteCount}]</div><div>用户：新增[${user.createCount}];匹配[${user.matchCount}];删除[${user.deleteCount}]</div>`
          //   })
          // } else {
          //   this.$Message.success('同步成功')
          // }
          this.$Notice.success({
            title: '同步成功',
            desc: title,
            duration: 0,
          })
        } else {
          this.$Notice.error({
            title: '同步失败',
            desc: title,
            duration: 0,
          })
        }
      } catch(err) {
        console.error(err)
        this.$Spin.hide()
        this.$Notice.error({
          title: '同步失败',
          desc: title,
          duration: 0,
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.syncorguser {
  li {
    list-style: none;
    padding: 15px;
    // margin: 10px 0;
    // border: 1px solid #ddd;
    // border-radius: 5px;
  }
  li+li {
    border-top: 1px solid #ddd;
  }
  li:hover {
    background: #F0F8FF;
  }
  .sync-btn {
    float: right;
  }
}
</style>
